import { Article, ArticleTagType } from '@/redux/modules/article/article.types';
import { ARTICLE_LINKS_LIMIT, SearchArticleLinksParams } from '@/redux/modules/articleLinks/articleLinks.types';

export const getArticlePageLinksParams = (article: Article | null): SearchArticleLinksParams | undefined => {
    const brand = article?.tags?.find((tag) => tag.type === ArticleTagType.Brand)?.value;
    if (brand) {
        return { brand, searchLimit: ARTICLE_LINKS_LIMIT };
    }

    const category = article?.tags?.find((tag) => tag.type === ArticleTagType.Category)?.value;
    if (category) {
        return { category, searchLimit: ARTICLE_LINKS_LIMIT };
    }

    return undefined;
};
